<template>
    <div class="mt-2 mt-md-3 mt-xl-4">
        <div v-for="contract in contractualDocuments" :key="contract.label">
            <div class="row">
                <div class="col-12">
                    <ob1-liens
                        :href="contract.link + '?webview_action=pdf'"
                        :target="webView ? '_self' : '_blank'"
                        :text="contract.label"
                        :with-arrow="true"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    contractualDocuments: {
      type: Array,
      required: true
    },
    webView: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
